import { useEffect } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const seen = new Set();

export function useNotifications(enabled) {
  useEffect(() => {
    if (!enabled) return;
    const poll = async () => {
      try {
        const { data } = await api.get("/broker/notifications");
        const fresh = data.filter((n) => !seen.has(n.notification_id));
        if (!fresh.length) return;
        fresh.forEach((n) => {
          seen.add(n.notification_id);
          toast(n.title, { description: n.body, duration: 10000, action: n.session_id ? { label: "Open chat", onClick: () => { window.location.href = `/broker?session=${n.session_id}`; } } : undefined });
          if ("Notification" in window && Notification.permission === "granted") {
            try { new Notification(n.title, { body: n.body, tag: n.notification_id }); } catch { /* ignore */ }
          }
        });
        await api.post("/broker/notifications/read");
      } catch { /* ignore */ }
    };
    poll();
    const id = setInterval(poll, 60000);
    return () => clearInterval(id);
  }, [enabled]);
}
